import {
  OtoIndividualProductRow,
  OtoIndividualProductsFilters
} from '../../lib/types/models/product/product-oto-individual'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOtoIndividualProducts(filter?: OtoIndividualProductsFilters) {
  return restApiClient
    .url(encodeNestedObject(API.products.getOtoIndividualProducts.url, { ...filter }))
    .get<OtoIndividualProductRow[]>()
}
